import { CardStatus, CollectionDeliveryTypes } from '$util/types';

import type { SchedulePageCardsStatus } from './SchedulePageCardsStatus';

export const determinePageStateCurrent = (
  collectionAddressId?: number,
  collectionDateTimeLocal?: string,
  deliveryDateTimeLocal?: string,
  garageId?: string,
  collectionDeliveryOption?: CollectionDeliveryTypes
): SchedulePageCardsStatus => {
  if (!collectionDeliveryOption || collectionDeliveryOption === CollectionDeliveryTypes.UNKNOWN)
    return {
      address: CardStatus.INACTIVE,
      outOfCoverage: CardStatus.SKIP,
      selectTransportMethod: CardStatus.ACTIVE,
      collection: CardStatus.INACTIVE,
      delivery: CardStatus.INACTIVE,
      selectGarage: CardStatus.SKIP,
      selectGarageDropoff: CardStatus.SKIP,
    };

  if (!collectionAddressId) {
    return {
      address: CardStatus.ACTIVE,
      outOfCoverage: CardStatus.SKIP,
      selectTransportMethod: CardStatus.COMPLETED,
      collection: CardStatus.INACTIVE,
      delivery: CardStatus.INACTIVE,
      selectGarage: CardStatus.SKIP,
      selectGarageDropoff: CardStatus.SKIP,
    };
  }

  const outOfCoverage = collectionDeliveryOption === CollectionDeliveryTypes.OUT_OF_COVERAGE;

  if (outOfCoverage) {
    return {
      address: CardStatus.COMPLETED,
      outOfCoverage: CardStatus.ACTIVE,
      selectTransportMethod: CardStatus.SKIP,
      collection: CardStatus.SKIP,
      delivery: CardStatus.SKIP,
      selectGarage: CardStatus.SKIP,
      selectGarageDropoff: CardStatus.SKIP,
    };
  }

  if (
    ![
      CollectionDeliveryTypes.FIXTER,
      CollectionDeliveryTypes.GARAGE,
      CollectionDeliveryTypes.CUSTOMER,
    ].includes(collectionDeliveryOption as CollectionDeliveryTypes)
  ) {
    return {
      address: CardStatus.COMPLETED,
      outOfCoverage: CardStatus.SKIP,
      selectTransportMethod: CardStatus.ACTIVE,
      collection: CardStatus.INACTIVE,
      delivery: CardStatus.INACTIVE,
      selectGarage: CardStatus.SKIP,
      selectGarageDropoff: CardStatus.SKIP,
    };
  }

  if (
    [CollectionDeliveryTypes.FIXTER, CollectionDeliveryTypes.GARAGE].includes(
      collectionDeliveryOption as CollectionDeliveryTypes
    )
  ) {
    if (deliveryDateTimeLocal) {
      return {
        address: CardStatus.COMPLETED,
        outOfCoverage: CardStatus.SKIP,
        selectTransportMethod: CardStatus.COMPLETED,
        collection: CardStatus.COMPLETED,
        delivery: CardStatus.COMPLETED,
        selectGarage: CardStatus.SKIP,
        selectGarageDropoff: CardStatus.SKIP,
      };
    }
    if (collectionDateTimeLocal) {
      return {
        address: CardStatus.COMPLETED,
        outOfCoverage: CardStatus.SKIP,
        selectTransportMethod: CardStatus.COMPLETED,
        collection: CardStatus.COMPLETED,
        delivery: CardStatus.ACTIVE,
        selectGarage: CardStatus.SKIP,
        selectGarageDropoff: CardStatus.SKIP,
      };
    }
    return {
      address: CardStatus.COMPLETED,
      outOfCoverage: CardStatus.SKIP,
      selectTransportMethod: CardStatus.COMPLETED,
      collection: CardStatus.ACTIVE,
      delivery: CardStatus.INACTIVE,
      selectGarage: CardStatus.SKIP,
      selectGarageDropoff: CardStatus.SKIP,
    };
  }

  if ([CollectionDeliveryTypes.CUSTOMER].includes(collectionDeliveryOption as CollectionDeliveryTypes)) {
    if (deliveryDateTimeLocal) {
      return {
        address: CardStatus.COMPLETED,
        outOfCoverage: CardStatus.SKIP,
        selectTransportMethod: CardStatus.COMPLETED,
        collection: CardStatus.SKIP,
        delivery: CardStatus.SKIP,
        selectGarage: CardStatus.COMPLETED,
        selectGarageDropoff: CardStatus.COMPLETED,
      };
    }
    if (collectionDateTimeLocal) {
      return {
        address: CardStatus.COMPLETED,
        outOfCoverage: CardStatus.SKIP,
        selectTransportMethod: CardStatus.COMPLETED,
        collection: CardStatus.SKIP,
        delivery: CardStatus.SKIP,
        selectGarage: CardStatus.COMPLETED,
        selectGarageDropoff: CardStatus.ACTIVE,
      };
    }
    if (garageId) {
      return {
        address: CardStatus.COMPLETED,
        outOfCoverage: CardStatus.SKIP,
        selectTransportMethod: CardStatus.COMPLETED,
        collection: CardStatus.SKIP,
        delivery: CardStatus.SKIP,
        selectGarage: CardStatus.COMPLETED,
        selectGarageDropoff: CardStatus.ACTIVE,
      };
    }
    return {
      address: CardStatus.COMPLETED,
      outOfCoverage: CardStatus.SKIP,
      selectTransportMethod: CardStatus.COMPLETED,
      collection: CardStatus.SKIP,
      delivery: CardStatus.SKIP,
      selectGarage: CardStatus.ACTIVE,
      selectGarageDropoff: CardStatus.INACTIVE,
    };
  }

  return {
    address: CardStatus.INACTIVE,
    outOfCoverage: CardStatus.INACTIVE,
    selectTransportMethod: CardStatus.ACTIVE,
    collection: CardStatus.INACTIVE,
    delivery: CardStatus.INACTIVE,
    selectGarage: CardStatus.SKIP,
    selectGarageDropoff: CardStatus.SKIP,
  };
};
